import React from 'react';
import { ArticlePage } from './pages/ArticlePage';
export function App() {
  return <ArticlePage data-id="element-0" data-mp="35ckbubl5pal3" />;
}